export default "__VITE_ASSET__B70Y8Rpt__"